import { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import BeforeGoToKorea from './pages/BeforeGoToKorea';
import LanguageTraining from './pages/LanguageTraining';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import News from './pages/News';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import RefundPolicy from './pages/RefundPolicy';
import Footer from './components/Footer';
import flagRound from './assets/images/flag-round.webp';
import Snowfall from './components/Snowfall';

const normalizePath = (path) => {
  if (path === '/privacy-policy' || path === '/privacy-policy/') return '/privacy-policy/';
  if (path === '/terms-conditions' || path === '/terms-conditions/') return '/terms-conditions/';
  if (path === '/refund-policy' || path === '/refund-policy/') return '/refund-policy/';
  if (!path || path === '/') return '/';
  return path.endsWith('/') ? path.slice(0, -1) : path;
};

function App() {
  const [currentPath, setCurrentPath] = useState(normalizePath(window.location.pathname));
  const [showPreloader, setShowPreloader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowPreloader(false), 1700);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (showPreloader) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [showPreloader]);

  useEffect(() => {
    const handlePathChange = () => {
      setCurrentPath(normalizePath(window.location.pathname));
      window.scrollTo(0, 0);
    };

    window.addEventListener('popstate', handlePathChange);
    return () => window.removeEventListener('popstate', handlePathChange);
  }, []);

  const handleNavigate = (path) => {
    const nextPath = normalizePath(path);
    if (nextPath === currentPath) {
      window.scrollTo(0, 0);
      return;
    }
    window.history.pushState({}, '', nextPath);
    setCurrentPath(nextPath);
    window.scrollTo(0, 0);
  };

  const renderPage = () => {
    if (currentPath === '/before-korea') {
      return <BeforeGoToKorea />;
    }
    if (currentPath === '/language') {
      return <LanguageTraining />;
    }
    if (currentPath === '/contact') {
      return <Contact />;
    }
    if (currentPath === '/faq') {
      return <FAQ />;
    }
    if (currentPath === '/news') {
      return <News />;
    }
    if (currentPath === '/privacy-policy/') {
      return <PrivacyPolicy />;
    }
    if (currentPath === '/terms-conditions/') {
      return <TermsConditions />;
    }
    if (currentPath === '/refund-policy/') {
      return <RefundPolicy />;
    }
    return <Home />;
  };

  return (
    <div className="App">
      <Snowfall />
      {showPreloader && (
        <div className="app-preloader">
          <div className="preloader-flag-wrap">
            <img src={flagRound} alt="South Korea Flag" className="preloader-flag" />
          </div>
        </div>
      )}
      <Navbar currentPath={currentPath} onNavigate={handleNavigate} />
      <main className="App-main">
        {renderPage()}
      </main>
      <Footer onNavigate={handleNavigate} />
    </div>
  );
}

export default App;
